import React from "react";
import {
  Moon,
  Bed,
  Cussion,
  GreenThumb,
  SleepQUalityFocus,
  LifeStyleHabit,
  MindAndStress,
  Enviornment,
  SleepSchedule,
  ScheduleNew,
  MindNew,
  LifestyleNew,
  QualityNew,
  EnvoirnmentNew,
} from "@utils/defaultImages.js";

export const getSleepCoachTrackingData = ({ trackingData, adviseData, t }) => {
  return [
    {
      label: t("sleepCoachPreferences.avgSleepDuration"),
      key: "average_sleep_duration",
      icon: <Moon className="w-[24px] h-[24px]" />,
      tabColor: "#F0FFFF",
      value: trackingData?.average_sleep_duration ?? "0h 0min",
    },
    {
      label: t("sleepCoachPreferences.wakeUpsPerWeek"),
      key: "wake_ups_per_week",
      icon: <Bed className="w-[24px] h-[24px]" />,
      tabColor: "#FFF0FB",
      value: `${trackingData?.wake_ups_per_week ?? 0} ${t(
        "sleepCoachPreferences.nights"
      )}`,
    },
    {
      label: t("sleepCoachPreferences.sleepConsistency"),
      key: "sleep_consistency_days",
      icon: <Cussion className="w-[24px] h-[24px]" />,
      tabColor: "#FFF6F0",
      value: `${trackingData?.sleep_consistency_days ?? 0} ${t(
        "sleepCoachPreferences.days"
      )}`,
    },
    {
      label: t("sleepCoachPreferences.adviceFollowed"),
      key: "advice_followed",
      icon: <GreenThumb className="w-[24px] h-[24px]" />,
      tabColor: "#F5FFF0",
      value: `${trackingData?.advice_followed?.days_followed ?? 0} of ${
        adviseData?.length ?? 7
      } ${t("sleepCoachPreferences.days")}`,
    },
  ];
};

export const getSleepCoachStepsData = ({ sleepCoachStepsData, t }) => {
  return [
    {
      bg: ScheduleNew,
      label: t("Sleep Schedule"),
      key: "Sleep Schedule",
      icon: <SleepSchedule className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: sleepCoachStepsData?.["Sleep Schedule"],
      model_value:
        sleepCoachStepsData?.["Sleep Schedule Detail"] ??
        sleepCoachStepsData?.["Sleep Schedule"],
    },
    {
      bg: EnvoirnmentNew,
      label: t("Environment"),
      key: "environment",
      icon: <Enviornment className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: sleepCoachStepsData?.["Environment"],
      model_value:
        sleepCoachStepsData?.["Environment Detail"] ??
        sleepCoachStepsData?.["Environment"],
    },
    {
      bg: MindNew,
      label: t("Mind & Stress"),
      key: "mind_stress",
      icon: <MindAndStress className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: sleepCoachStepsData?.["Mind & Stress"],
      model_value:
        sleepCoachStepsData?.["Mind & Stress Detail"] ??
        sleepCoachStepsData?.["Mind & Stress"],
    },
    {
      bg: LifestyleNew,
      label: t("Lifestyle Habits"),
      key: "lifestyle_habits",
      icon: <LifeStyleHabit className="w-[28px] h-[28px]" />,
      tabColor: "#FFF0FB",
      value: sleepCoachStepsData?.["Lifestyle Habits"],
      model_value:
        sleepCoachStepsData?.["Lifestyle Habits Detail"] ??
        sleepCoachStepsData?.["Lifestyle Habits"],
    },
    {
      bg: QualityNew,
      label: t("Sleep Quality Focus"),
      key: "sleep_quality_focus",
      icon: <SleepQUalityFocus className="w-[28px] h-[28px]" />,
      tabColor: "#FFF0FF",
      value: sleepCoachStepsData?.["Sleep Quality Focus"],
      model_value:
        sleepCoachStepsData?.["Sleep Quality Focus Detail"] ??
        sleepCoachStepsData?.["Sleep Quality Focus"],
    },
  ];
};
